import {CustodyCertificateService} from "../../custody_certificate_service";
import {buildDataSteps} from "./mock_custody_certificate";

export class CustodyCertificateServiceV2 extends CustodyCertificateService {
  buildDataSteps(){
    return buildDataSteps();
  }
}